export function headerFunc() {
  const header = document.getElementById('header');
  const megaItems = document.querySelectorAll('.l-header__nav-list--mega');
  const searchWrap = header?.querySelector('.l-header__search-wrap');
  const searchTrigger = searchWrap?.querySelector('.l-header__nav-search');
  const searchPanel = searchWrap?.querySelector('.l-header__mega--search');
  const navWrap = document.querySelector('.l-header__nav-wrap');
  const nav = document.querySelector('.l-header__nav');
  const bottomNav = document.querySelector('.l-bottom-nav');
  const bottomNavItems = bottomNav?.querySelectorAll('.l-bottom-nav__item');
  const bottomNavButtons = bottomNav?.querySelectorAll('[data-bottom-nav]');
  const bottomNavModal = document.querySelector('.l-bottom-nav-modal');
  const bottomNavModalInner = bottomNavModal?.querySelector('.l-bottom-nav-modal__inner');
  const navCloseButton = document.querySelector('.l-header__nav-close');
  const mobileBackdrop = document.querySelector('.l-header__mobile-backdrop');
  const megaBackdrop = document.getElementById('header-mega-backdrop');
  const concernsLi = document.getElementById('mega-concerns')?.closest('.l-header__nav-list--mega') ?? null;
  const solutionsLi = document.getElementById('mega-solutions')?.closest('.l-header__nav-list--mega') ?? null;
  const diagnosisLink =
    Array.from(header?.querySelectorAll('.l-header__nav-list a') ?? []).find((a) =>
      a.textContent?.trim().includes('マネジメント診断'),
    ) ?? null;
  const mqDesktop = window.matchMedia('(min-width: 1280px)');
  const mqMegaAutoClose = window.matchMedia('(min-width: 1280px)');
  const OPEN_ON_HOVER_DESKTOP = false;
  const BODY_SCROLLED_CLASS = 'is-scrolled';
  const BODY_SCROLL_THRESHOLD = 1;
  const PC_HEADER_SHELL_PINNED_CLASS = 'is-pc-header-viewport-stick';
  const PC_HEADER_SHELL_REVEAL_CLASS = 'is-pc-header-stick-reveal';
  /** PC: l-header__top 相当のピン閾値・固定オフセット（_header.scss .l-header__top と揃える） */
  const PC_HEADER_TOP_BAND_DESKTOP_PX = 128;
  const PC_HEADER_PIN_COMPACT_CLASS = 'is-pc-header-pin-compact';
  const PC_HEADER_PIN_COMPACT_EXPAND_CLASS = 'is-pc-header-pin-compact-expanded';
  /** ピン中の上／下判定（SP ヘッダと同系のしきい値） */
  const PC_HEADER_COMPACT_DIR_THRESHOLD_PX = 8;
  const SP_HEADER_SCROLL_HIDDEN_CLASS = 'is-sp-header-scroll-hidden';
  const SP_HEADER_TOP_SHOW_PX = 24;
  const SP_HEADER_DIRECTION_THRESHOLD_PX = 8;
  const RELOAD_SCROLL_STORAGE_KEY = 'ownedCreiaReloadScrollPosition';
  let spHeaderLastScrollY = typeof window.scrollY === 'number' ? window.scrollY : 0;
  /** PC コンパクト固定中の scroll 方向検出用 */
  let pcCompactLastScrollY = typeof window.scrollY === 'number' ? window.scrollY : 0;
  /** SP: body の padding-top 用にヘッダー見出し高さを CSS 変数へ（非表示時は 0） */
  function syncSpHeaderInset() {
    if (!header || mqDesktop.matches) {
      document.documentElement.style.removeProperty('--owned-creia-sp-header-bar-h');
      return;
    }
    if (document.body.classList.contains(SP_HEADER_SCROLL_HIDDEN_CLASS)) {
      document.documentElement.style.setProperty('--owned-creia-sp-header-bar-h', '0px');
      return;
    }
    document.documentElement.style.setProperty('--owned-creia-sp-header-bar-h', `${header.offsetHeight}px`);
  }

  function forceShowSpHeader() {
    if (mqDesktop.matches || !header) {
      return;
    }
    document.body.classList.remove(SP_HEADER_SCROLL_HIDDEN_CLASS);
    syncSpHeaderInset();
    spHeaderLastScrollY = window.scrollY || 0;
  }

  function updateSpHeaderScrollVisibility() {
    if (!header) {
      return;
    }
    if (mqDesktop.matches) {
      document.body.classList.remove(SP_HEADER_SCROLL_HIDDEN_CLASS);
      document.documentElement.style.removeProperty('--owned-creia-sp-header-bar-h');
      return;
    }

    const y = window.scrollY || 0;
    const forceVisible =
      y <= SP_HEADER_TOP_SHOW_PX ||
      !!header.classList.contains('l-header--nav-panel-open') ||
      !!nav?.classList.contains('l-header__nav--open') ||
      !!bottomNavModal?.classList.contains('is-open');

    if (forceVisible) {
      document.body.classList.remove(SP_HEADER_SCROLL_HIDDEN_CLASS);
      syncSpHeaderInset();
      spHeaderLastScrollY = y;
      return;
    }

    if (y > spHeaderLastScrollY + SP_HEADER_DIRECTION_THRESHOLD_PX) {
      document.body.classList.add(SP_HEADER_SCROLL_HIDDEN_CLASS);
      syncSpHeaderInset();
    } else if (y < spHeaderLastScrollY - SP_HEADER_DIRECTION_THRESHOLD_PX) {
      document.body.classList.remove(SP_HEADER_SCROLL_HIDDEN_CLASS);
      syncSpHeaderInset();
    }

    spHeaderLastScrollY = y;
  }

  /**
   * 旧 PC シェル実装の残骸のみ除去（SP は触らない）。
   */
  function stripObsoletePcShellClasses() {
    document.body.classList.remove(PC_HEADER_SHELL_PINNED_CLASS);
    document.body.classList.remove(PC_HEADER_SHELL_REVEAL_CLASS);
    document.documentElement.style.removeProperty('--owned-creia-pc-shell-spacer-h');
  }

  /** PC でスクロール依存のヘッダーモードをすべてオフ（≤1279px にしたとき等） */
  function teardownPcDesktopCompactHeader() {
    stripObsoletePcShellClasses();
    document.body.classList.remove(PC_HEADER_PIN_COMPACT_CLASS);
    document.body.classList.remove(PC_HEADER_PIN_COMPACT_EXPAND_CLASS);
  }

  /**
   * PC: 先頭から 128px スクロール後ヘッダー固定。
   * ピン中: 上スクロールで .l-header を top:0（フル表示）、下スクロールで top:-128px。
   */
  function updatePcHeaderCompactStick() {
    if (!mqDesktop.matches || !header) {
      teardownPcDesktopCompactHeader();
      return;
    }

    stripObsoletePcShellClasses();

    const y = typeof window.scrollY === 'number' ? window.scrollY : 0;
    const compact = y >= PC_HEADER_TOP_BAND_DESKTOP_PX;
    const wasCompact = document.body.classList.contains(PC_HEADER_PIN_COMPACT_CLASS);

    document.body.classList.toggle(PC_HEADER_PIN_COMPACT_CLASS, compact);

    if (!compact) {
      document.body.classList.remove(PC_HEADER_PIN_COMPACT_EXPAND_CLASS);
      pcCompactLastScrollY = y;
      return;
    }

    if (!wasCompact) {
      document.body.classList.remove(PC_HEADER_PIN_COMPACT_EXPAND_CLASS);
    }

    const scrollingDown = y > pcCompactLastScrollY + PC_HEADER_COMPACT_DIR_THRESHOLD_PX;
    const scrollingUp = y < pcCompactLastScrollY - PC_HEADER_COMPACT_DIR_THRESHOLD_PX;
    if (scrollingDown) {
      document.body.classList.remove(PC_HEADER_PIN_COMPACT_EXPAND_CLASS);
    } else if (scrollingUp) {
      document.body.classList.add(PC_HEADER_PIN_COMPACT_EXPAND_CLASS);
    }

    pcCompactLastScrollY = y;
  }

  function getMegaLayoutAnchorEl() {
    return header ?? null;
  }

  function shouldStartAtTop() {
    const path = window.location.pathname.replace(/\/+$/, '') || '/';
    return !window.location.hash && (document.body.classList.contains('home') || path === '/assessment');
  }

  /** PC メガ展開時：ヘッダー下端に合わせて幕の top を更新 */
  function syncMegaBackdrop() {
    if (!megaBackdrop || !header) {
      return;
    }
    if (!mqDesktop.matches || !header.classList.contains('l-header--mega-open')) {
      megaBackdrop.style.removeProperty('--l-header-mega-backdrop-top');
      return;
    }
    const anchor = getMegaLayoutAnchorEl();
    if (!anchor) {
      megaBackdrop.style.removeProperty('--l-header-mega-backdrop-top');
      return;
    }
    const bottom = anchor.getBoundingClientRect().bottom;
    megaBackdrop.style.setProperty('--l-header-mega-backdrop-top', `${bottom}px`);
  }

  /** モバイルドロワー時はメガ用幕を触らない（CSS で非表示） */
  function resetMegaBackdropStylesForMobileNav() {
    megaBackdrop?.style.removeProperty('--l-header-mega-backdrop-top');
  }

  function restoreReloadScrollPositionIfNeeded() {
    if (shouldStartAtTop()) {
      try {
        sessionStorage.removeItem(RELOAD_SCROLL_STORAGE_KEY);
      } catch (_) {
        // sessionStorage が使えない環境では何もしない
      }
      return;
    }

    const path = window.location.pathname.replace(/\/+$/, '') || '/';
    const navigationEntry = performance.getEntriesByType('navigation')?.[0];
    const isReload = navigationEntry
      ? navigationEntry.type === 'reload'
      : performance.navigation?.type === 1;

    if (!isReload) {
      return;
    }

    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }

    restoreReloadScrollPosition(path);
  }

  function saveReloadScrollPosition() {
    if (shouldStartAtTop()) {
      return;
    }

    try {
      sessionStorage.setItem(
        RELOAD_SCROLL_STORAGE_KEY,
        JSON.stringify({
          path: window.location.pathname.replace(/\/+$/, '') || '/',
          y: window.scrollY || window.pageYOffset || 0,
        }),
      );
    } catch (_) {
      // sessionStorage が使えない環境ではブラウザ標準の復元に任せる
    }
  }

  function restoreReloadScrollPosition(path) {
    let saved = null;

    try {
      saved = JSON.parse(sessionStorage.getItem(RELOAD_SCROLL_STORAGE_KEY) || 'null');
    } catch (_) {
      saved = null;
    }

    if (!saved || saved.path !== path || typeof saved.y !== 'number') {
      return;
    }

    const restore = () => {
      window.scrollTo(0, saved.y);
    };

    restore();
    requestAnimationFrame(restore);
    window.setTimeout(restore, 50);
    window.setTimeout(restore, 300);
    window.setTimeout(restore, 800);
  }

  function updateBodyScrolledClass() {
    if (mqDesktop.matches) {
      document.body.classList.remove(BODY_SCROLLED_CLASS);
      return;
    }
    document.body.classList.toggle(BODY_SCROLLED_CLASS, window.scrollY >= BODY_SCROLL_THRESHOLD);
  }

  const Z_NAV_LI_OPEN = '1';
  const Z_NAV_LI_OTHERS = '30';

  function clearMegaNavStacking() {
    header?.querySelectorAll('.l-header__nav-list-wrap > li').forEach((item) => {
      item.style.removeProperty('z-index');
    });
    searchWrap?.style.removeProperty('z-index');
  }

  /** 開いている li だけ下げ、兄弟 li を上げる → 固定メガが横に重なっても隣メニューが操作できる */
  function applyNavMegaStack(openLi) {
    if (!mqDesktop.matches || !header || !openLi) {
      return;
    }
    clearMegaNavStacking();
    openLi.style.zIndex = Z_NAV_LI_OPEN;
    header.querySelectorAll('.l-header__nav-list-wrap > li').forEach((item) => {
      if (item !== openLi) {
        item.style.zIndex = Z_NAV_LI_OTHERS;
      }
    });
  }

  /** 検索メガ時はナビ列全体を検索ブロックより手前に */
  function applySearchMegaStack() {
    if (!mqDesktop.matches || !header) {
      return;
    }
    clearMegaNavStacking();
    header.querySelectorAll('.l-header__nav-list-wrap > li').forEach((item) => {
      item.style.zIndex = Z_NAV_LI_OTHERS;
    });
    if (searchWrap) {
      searchWrap.style.zIndex = Z_NAV_LI_OPEN;
    }
  }

  function syncMegaLayout() {
    syncMegaBackdrop();
    if (!header || !mqDesktop.matches) {
      return;
    }
    const openLi = header.querySelector('.l-header__nav-list--mega.is-open');
    const openSearch = searchWrap?.classList.contains('is-open');
    let mega;
    let trigger;

    if (openLi) {
      mega = openLi.querySelector('.l-header__mega');
      trigger = openLi.querySelector('.l-header__nav-trigger');
    } else if (openSearch) {
      mega = searchPanel ?? undefined;
      trigger = searchTrigger ?? undefined;
    } else {
      return;
    }

    if (!mega || !trigger) {
      return;
    }

    const gap = 0;
    const anchor = getMegaLayoutAnchorEl();
    if (!anchor) {
      return;
    }
    const bottom = anchor.getBoundingClientRect().bottom;
    mega.style.setProperty('--l-header-mega-top', `${bottom + gap}px`);

    const placeCaret = () => {
      const tr = trigger.getBoundingClientRect();
      const mr = mega.getBoundingClientRect();
      const pad = 20;
      const cx = tr.left + tr.width / 2;

      if (mr.width < pad * 2) {
        mega.style.setProperty('--mega-caret-left', '50%');
        return;
      }

      let caretLeft = cx - mr.left;
      caretLeft = Math.min(Math.max(caretLeft, pad), mr.width - pad);
      mega.style.setProperty('--mega-caret-left', `${caretLeft}px`);
    };
    requestAnimationFrame(placeCaret);
  }

  function closeAllNavMegas() {
    megaItems.forEach((li) => {
      li.classList.remove('is-open');
      const trigger = li.querySelector('.l-header__nav-trigger');
      const panel = li.querySelector('.l-header__mega');
      trigger?.setAttribute('aria-expanded', 'false');
      panel?.setAttribute('aria-hidden', 'true');
      panel?.style.removeProperty('--mega-caret-left');
      panel?.style.removeProperty('--l-header-mega-top');
    });
  }

  function closeSearchMega() {
    searchWrap?.classList.remove('is-open');
    searchTrigger?.setAttribute('aria-expanded', 'false');
    searchPanel?.setAttribute('aria-hidden', 'true');
    searchPanel?.style.removeProperty('--mega-caret-left');
    searchPanel?.style.removeProperty('--l-header-mega-top');
  }

  function closeAllMegas(resetActive = true) {
    closeAllNavMegas();
    closeSearchMega();
    header?.classList.remove('l-header--mega-open');
    header?.classList.remove('l-header--mega-modal-open');
    clearMegaNavStacking();
    syncMegaBackdrop();
    if (resetActive) {
      setBottomNavActive(null);
    }
  }

  function openMega(li) {
    closeSearchMega();
    megaItems.forEach((item) => {
      const open = item === li;
      item.classList.toggle('is-open', open);
      const trigger = item.querySelector('.l-header__nav-trigger');
      const panel = item.querySelector('.l-header__mega');
      trigger?.setAttribute('aria-expanded', String(open));
      panel?.setAttribute('aria-hidden', String(!open));
    });
    if (mqDesktop.matches) {
      header?.classList.add('l-header--mega-open');
      applyNavMegaStack(li);
      syncMegaLayout();
    } else {
      header?.classList.remove('l-header--mega-open');
      header?.classList.add('l-header--mega-modal-open');
      clearMegaNavStacking();
    }
  }

  function toggleMega(li, resetActiveOnClose = true) {
    if (li.classList.contains('is-open')) {
      closeAllMegas(resetActiveOnClose);
    } else {
      openMega(li);
    }
  }

  function openSearchMega() {
    closeAllNavMegas();
    searchWrap?.classList.add('is-open');
    searchTrigger?.setAttribute('aria-expanded', 'true');
    searchPanel?.setAttribute('aria-hidden', 'false');
    if (mqDesktop.matches) {
      header?.classList.add('l-header--mega-open');
      applySearchMegaStack();
      syncMegaLayout();
    } else {
      header?.classList.remove('l-header--mega-open');
      clearMegaNavStacking();
    }
  }

  function toggleSearchMega() {
    if (searchWrap?.classList.contains('is-open')) {
      closeAllMegas();
    } else {
      openSearchMega();
    }
  }

  function setBottomNavActive(key) {
    bottomNavItems?.forEach((item) => {
      if (!item.hasAttribute('data-bottom-nav')) {
        return;
      }
      const k = item.getAttribute('data-bottom-nav') ?? '';
      item.classList.toggle('is-active', !!key && key === k);
    });
  }

  function closeBottomNavModal(resetActive = true) {
    bottomNavModal?.classList.remove('is-open');
    bottomNavModal?.setAttribute('aria-hidden', 'true');
    bottomNavModal?.removeAttribute('data-bottom-nav-current');
    if (bottomNavModalInner) {
      bottomNavModalInner.innerHTML = '';
    }
    if (resetActive) {
      setBottomNavActive(null);
    }
    updateSpHeaderScrollVisibility();
  }

  function openBottomNavModal(key, sourceLi) {
    if (mqDesktop.matches || !bottomNavModal || !bottomNavModalInner || !sourceLi) {
      return;
    }

    const currentKey = bottomNavModal.getAttribute('data-bottom-nav-current');
    if (bottomNavModal.classList.contains('is-open') && currentKey === key) {
      closeBottomNavModal();
      return;
    }

    closeMobileNavPanel();
    closeAllNavMegas();
    closeSearchMega();

    const clonedLi = sourceLi.cloneNode(true);
    clonedLi.classList.add('is-open');
    clonedLi.classList.add('l-bottom-nav-modal__content');
    clonedLi.querySelectorAll('[id]').forEach((item) => {
      item.removeAttribute('id');
    });
    clonedLi.querySelectorAll('[aria-controls], [aria-labelledby], [aria-expanded], [aria-hidden]').forEach((item) => {
      item.removeAttribute('aria-controls');
      item.removeAttribute('aria-labelledby');
      item.removeAttribute('aria-expanded');
      item.removeAttribute('aria-hidden');
    });

    bottomNavModalInner.innerHTML = '';
    bottomNavModalInner.appendChild(clonedLi);
    bottomNavModal.setAttribute('data-bottom-nav-current', key);
    bottomNavModal.setAttribute('aria-hidden', 'false');
    bottomNavModal.classList.add('is-open');
    forceShowSpHeader();
    setBottomNavActive(key);
  }

  function openMobileNavPanel() {
    if (mqDesktop.matches) {
      return;
    }
    header?.classList.add('l-header--nav-panel-open');
    nav?.classList.add('l-header__nav--open');
    forceShowSpHeader();
    resetMegaBackdropStylesForMobileNav();
  }

  function closeMobileNavPanel() {
    header?.classList.remove('l-header--nav-panel-open');
    nav?.classList.remove('l-header__nav--open');
    closeAllMegas();
    updateSpHeaderScrollVisibility();
  }

  syncMegaBackdrop();
  restoreReloadScrollPositionIfNeeded();
  stripObsoletePcShellClasses();
  updatePcHeaderCompactStick();
  requestAnimationFrame(() => {
    stripObsoletePcShellClasses();
    updatePcHeaderCompactStick();
  });
  updateBodyScrolledClass();
  syncSpHeaderInset();
  requestAnimationFrame(() => {
    syncSpHeaderInset();
    updateSpHeaderScrollVisibility();
  });

  megaItems.forEach((li) => {
    const trigger = li.querySelector('.l-header__nav-trigger');

    li.addEventListener('mouseenter', () => {
      if (!OPEN_ON_HOVER_DESKTOP) {
        return;
      }
      if (!mqDesktop.matches) {
        return;
      }
      openMega(li);
    });

    trigger?.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      closeBottomNavModal(false);
      toggleMega(li, mqDesktop.matches || !header?.classList.contains('l-header--nav-panel-open'));
    });
  });

  if (searchWrap) {
    searchWrap.addEventListener('mouseenter', () => {
      if (!OPEN_ON_HOVER_DESKTOP) {
        return;
      }
      if (!mqDesktop.matches) {
        return;
      }
      openSearchMega();
    });
  }

  bottomNavButtons?.forEach((btn) => {
    btn.addEventListener('click', (e) => {
      if (mqDesktop.matches) {
        return;
      }
      const target = btn.getAttribute('data-bottom-nav');
      if (target === 'menu') {
        closeBottomNavModal();
        if (header?.classList.contains('l-header--nav-panel-open')) {
          closeMobileNavPanel();
          setBottomNavActive(null);
        } else {
          openMobileNavPanel();
          closeAllMegas();
          setBottomNavActive('menu');
        }
        return;
      }
      if (target === 'diagnosis') {
        closeBottomNavModal();
        openMobileNavPanel();
        if (diagnosisLink) {
          const href = diagnosisLink.getAttribute('href');
          if (href && href !== '#') {
            window.location.href = href;
            return;
          }
          diagnosisLink.focus?.();
        }
        setBottomNavActive('diagnosis');
        return;
      }
      e.preventDefault();
      if (target === 'concerns' && concernsLi) {
        openBottomNavModal('concerns', concernsLi);
      } else if (target === 'solutions' && solutionsLi) {
        openBottomNavModal('solutions', solutionsLi);
      }
    });
  });

  navCloseButton?.addEventListener('click', () => {
    closeMobileNavPanel();
    setBottomNavActive(null);
  });

  navWrap?.addEventListener('click', (e) => {
    if (mqDesktop.matches || !header?.classList.contains('l-header--nav-panel-open')) {
      return;
    }
    const target = e.target;
    if (target instanceof Node && nav?.contains(target)) {
      return;
    }
    closeMobileNavPanel();
    setBottomNavActive(null);
  });

  mobileBackdrop?.addEventListener('click', () => {
    closeAllMegas();
  });

  megaBackdrop?.addEventListener('click', () => {
    if (!mqDesktop.matches) {
      return;
    }
    closeAllMegas();
  });

  bottomNavModal?.addEventListener('click', (e) => {
    if (mqDesktop.matches) {
      return;
    }
    const target = e.target;
    if (target instanceof Node && bottomNavModalInner?.contains(target)) {
      return;
    }
    closeBottomNavModal();
  });

  searchTrigger?.addEventListener('click', (e) => {
    e.preventDefault();
    e.stopPropagation();
    const wasOpen = searchWrap?.classList.contains('is-open');
    toggleSearchMega();
    if (!wasOpen && searchWrap?.classList.contains('is-open')) {
      document.getElementById('header-search-q')?.focus();
    }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      closeBottomNavModal();
      closeAllMegas();
    }
  });

  /** PC: メガパネル（.l-header__mega）外をクリックしたときだけ閉じる（トリガーは stopPropagation） */
  document.addEventListener('click', (e) => {
    if (!mqMegaAutoClose.matches || !header?.classList.contains('l-header--mega-open')) {
      return;
    }
    const t = e.target;
    const openNavMega = header.querySelector('.l-header__nav-list--mega.is-open .l-header__mega');
    const searchOpen = searchWrap?.classList.contains('is-open');

    if (openNavMega instanceof Element && openNavMega.contains(t)) {
      return;
    }
    if (searchOpen && searchPanel instanceof Element && searchPanel.contains(t)) {
      return;
    }
    closeAllMegas();
  });

  function onMqOrResize() {
    if (!mqDesktop.matches) {
      teardownPcDesktopCompactHeader();
      closeAllMegas();
      syncSpHeaderInset();
      updateSpHeaderScrollVisibility();
    } else {
      closeBottomNavModal();
      header?.classList.remove('l-header--nav-panel-open');
      nav?.classList.remove('l-header__nav--open');
      stripObsoletePcShellClasses();
      updatePcHeaderCompactStick();
      updateSpHeaderScrollVisibility();
      if (header?.classList.contains('l-header--mega-open')) {
        syncMegaLayout();
      }
    }
  }

  mqDesktop.addEventListener('change', onMqOrResize);
  window.addEventListener('resize', onMqOrResize);
  window.addEventListener(
    'scroll',
    () => {
      updateSpHeaderScrollVisibility();
      updateBodyScrolledClass();
      if (mqDesktop.matches) {
        updatePcHeaderCompactStick();
        if (header?.classList.contains('l-header--mega-open')) {
          syncMegaLayout();
        }
      }
    },
    { passive: true },
  );
  window.addEventListener('beforeunload', saveReloadScrollPosition);

  const toggleButton = document.querySelector('.l-header__toggle-button');
  toggleButton?.addEventListener('click', () => {
    toggleButton.classList.toggle('l-header__toggle-button--close');
    nav?.classList.toggle('l-header__nav--open');
    closeAllMegas();
  });
}
